// extracted by mini-css-extract-plugin
export default {"wrapper":"CookeModal_wrapper__dPivw","submitBtn":"CookeModal_submitBtn__papX5","a":"CookeModal_a__7g+hK"};